import { render } from "./MoreInfo.vue?vue&type=template&id=6418cdce"
import script from "./MoreInfo.vue?vue&type=script&lang=js"
export * from "./MoreInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__